import axios from "axios";
import apiClient from "lib/api-client";
import { useQuery } from "@tanstack/react-query";

export const getAllStatusWiseOrders = async (clientCode) => {
  const res = await apiClient.get(`/api/v9/myBinnys/getClientAllOrdersAccordingToStatus`, { params: { clientCode } });
  return res.data?.data; // returns array
};

export const useOrderSummary = (clientCode) => {
  return useQuery({
    queryKey: ["order-summary", clientCode],
    queryFn: () => getAllStatusWiseOrders(clientCode),
    enabled: !!clientCode,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};
